/****   http.js   ****/
// 导入封装好的axios实例
import request from './java-request.js'
import requestInfo from './config.js'
import axios from 'axios'

const http = {
	/**
	 * methods: 请求
	 * @param url 请求地址
	 * @param params 请求参数
	 * @param extras 请求额外参数，如超时时间等，黄耿智：2023-09-01
	 */
	get(url, params, extras) {
		const config = {
			method: 'get',
			url: requestInfo.baseUrl() + url,
			...(extras||{})
		}
		if (params) config.params = params
		return request(config)
	},

	/**
	 * post请求

	 * @param {Object} url
	 * @param {Object} params
	 * @param {Object} extras请求额外参数，如超时时间等，黄耿智：2023-09-01
	 */
	post(url, params, extras) {
		const config = {
			method: 'post',
			url: requestInfo.baseUrl() + url,
			...(extras||{})
		}
		if (params) config.data = params
		return request(config)
	},
	all(arr){
		return axios.all(arr)
	},
	// 文件上传
	// 允许上传时指定相关参数，如超时时间，黄耿智：2023-09-01
	upload(url, params, extras) {
		if(extras){
			if(!extras.timeout){
				extras.timeout = 10 * 60 * 1000 ; //上传超时时间改为10分钟，黄耿智：2022-11-10
			}
		}
		else{
			extras = {
				timeout: 10 * 60 * 1000,//上传超时时间改为10分钟，黄耿智：2022-11-10
			}
		}

		const config = {
			method: 'post',
			url: requestInfo.baseUrl() + url,
			...(extras||{})
		}
		config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
		if (params) config.data = params
		return request(config)
	},
	put(url, params, extras) {
		const config = {
			method: 'put',
			url: requestInfo.baseUrl() + url,
			...(extras||{})
		}
		if (params) config.params = params
		return request(config)
	},
	delete(url, params, extras) {
		const config = {
			method: 'delete',
			url: requestInfo.baseUrl() + url,
			...(extras||{})
		}
		if (params) config.params = params
		return request(config)
	},
	// Post(url, params) {
	// 	const config = {
	// 		method: 'post',
	// 		url: requestInfo.dispatchUrl1() + url
	// 	}
	// 	if (params) config.data = params
	// 	return request(config)
	// }
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/java-https.js